import { theme as antdTheme } from 'antd';

export default function useAntdTheme() {
  const { useToken } = antdTheme;
  const { token: theme } = useToken();

  return theme;
}
